import { render } from "./generalsettings.vue?vue&type=template&id=516ee55e"
import script from "./generalsettings.vue?vue&type=script&lang=js"
export * from "./generalsettings.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tooltip_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSelect,QMarkupTable,QChip,QBtn,QMenu,QInput});
